import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import {Redirect} from 'react-router-dom';

import CopyBreakModal from 'components/break/CopyBreakModal';
import {endCopyChallengeAction, submitCopyChallenge} from "./actions";
import copyBreakFormConfig from 'components/break/copyBreakFormConfig'
import {formDataManager} from "hoc/formDataManager";
import {isNoU} from "../../utils/DBUtils";

const mapStateToProps = (state) => {
    let data;

    if (!isNoU(state.copyChallenge.copyChallengePermalink)) {
      data = {
          permalink: state.copyChallenge.copyChallengePermalink + '-copy'
      }
    }
    return {
        modalOpen: state.copyChallenge.copyingChallenge,
        data: data,
        creationError: state.copyChallenge.error,
        onlySaveUnchanged: false // Possible move to config of form data manager
    }
};

const mapDispatchToProps = (dispatch) => ({
    onSaveData: (data) => dispatch(submitCopyChallenge(data.permalink, data.lang)),
    handleClose: () => dispatch(endCopyChallengeAction())
});

const CopyBreakModalContainerConnected = connect(mapStateToProps, mapDispatchToProps);

const CopyBreakModalLifeCycle = lifecycle({
    componentWillUnmount: function () {
        this.props.handleClose();
    },

    componentWillReceiveProps(nextProps) {
        // if (this.props.modalOpen === true && nextProps.modalOpen === false) {
        //     this.props.reset();
        // }
    }
});

let CopyBreakFormDataManager = formDataManager({
    lang: "en-US"
}, copyBreakFormConfig);

const CopyBreakModalContainer = compose(
    CopyBreakModalContainerConnected,
    CopyBreakModalLifeCycle,
    CopyBreakFormDataManager
)(CopyBreakModal);

// TODO: Current version of react-router-redux wasn't working, try next version is release
/**
 * Quick redirect container based on whether a createdChallengeId exists
 */
const CopyBreakModalRedirectContainer = connect((state) => ({
    createdChallengeId: state.copyChallenge.createdChallengeId
}), null)((props) => (
    <div>
        {props.createdChallengeId ? <Redirect to={`/break/${props.createdChallengeId}/edit`}/> : ""}
    </div>
));

/**
 * Render modal and redirect separately because modal gets hidden when copy is pressed.
 * Separation makes sure redirect can actually be rendered.
 */
const CopyBreakModalContainerGroup = (props) => [
    <CopyBreakModalContainer key="CopyBreakModalContainer"/>,
    <CopyBreakModalRedirectContainer key="CopyBreakModalRedirect"/>
];

export default CopyBreakModalContainerGroup;



// WEBPACK FOOTER //
// ./public/pages/BreakCopy/CopyBreakModalContainer.jsx